export default __webpack_public_path__ + "static/media/home-active-tab-icon.86d8eb41.svg";